// Maybe we should can find a way to always get the API URL for the current plugin, without having specific code (since we will copy/paste this helpers often),
const apiUrl = mct_copytrack.api_url.replace(/\/+$/, "");

const jsonFetcher = url => fetch(url).then(r => r.json());

export { apiUrl, jsonFetcher };